import { ChangeDetectionStrategy, Component, EventEmitter, HostListener, Output, TemplateRef, ViewChild } from '@angular/core';

@Component({
  changeDetection: ChangeDetectionStrategy.OnPush,
  selector: 'app-table-data-row',
  standalone: true,
  imports: [],
  templateUrl: './table-data-row.component.html',
  styleUrl: './table-data-row.component.scss'
})
export class TableDataRowComponent {
  @ViewChild("contentTemplate", { read: TemplateRef, "static": true })
  // eslint-disable-next-line @tseslint/no-explicit-any
  public contentTemplateRef!: TemplateRef<any>;

  @Output() readonly rowClick: EventEmitter<void> = new EventEmitter<void>();


  @HostListener("click")
  public onRowClick (): void {
    this.rowClick.emit();
  }
}
